export default __webpack_public_path__ + "static/inter-ui-regular-4992a5bf0103a539aedc4f7ae13eba0d.woff2";